<template>
    
<h1>修正值</h1>

</template>

<script>
export default {
        
    data(){

        return {

        }
    }

}
</script>